import React from 'react';
import { AtriumLine } from './ui';
const PRIMARY_LINKS = [{
  label: 'Homes',
  href: '#top'
}, {
  label: 'Display Homes',
  href: '#latitude'
}, {
  label: 'Completed Homes',
  href: '#completed-homes'
}, {
  label: 'Awards',
  href: '#awards'
}];
const SECONDARY_LINKS = [{
  label: 'Our Team',
  href: '#team'
}, {
  label: 'House & Land',
  href: '#enquire'
}, {
  label: 'International Clients',
  href: '#enquire'
}, {
  label: 'Contact',
  href: '#enquire'
}];
const ACCREDITATIONS = ['HIA Member', 'MBA Member', 'Housing Excellence Awards'];
export function Footer() {
  return <footer className="bg-atrium-ink text-atrium-ivory pt-24 pb-12 md:pb-24 px-6 lg:px-8" data-id="element-19">
      <div className="max-w-7xl mx-auto" data-id="element-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 mb-16" data-id="element-21">
          {/* Brand & NAP */}
          <div className="md:col-span-5 lg:col-span-4" data-id="element-22">
            <a href="#top" className="flex flex-col items-start group mb-8 inline-block" data-id="element-23">
              <span className="font-serif text-3xl tracking-[0.1em] text-atrium-ivory uppercase leading-none" data-id="element-24">
                Atrium
              </span>
              <span className="font-sans text-[0.75rem] tracking-[0.2em] text-atrium-stone uppercase mt-1 ml-0.5" data-id="element-25">
                Homes
              </span>
            </a>

            <address className="not-italic text-sm text-atrium-stone space-y-2 leading-relaxed" data-id="element-26">
              <p data-id="element-27">
                9 Willcock Street,
                <br data-id="element-28" />
                Ardross WA 6153
              </p>
              <p className="pt-2" data-id="element-29">
                <a href="tel:+61863108888" className="hover:text-atrium-bronze transition-colors" data-id="element-30">
                  (08) 6310 8888
                </a>
              </p>
              <p data-id="element-31">Mon to Fri 8am to 5pm</p>
            </address>
          </div>

          {/* Links */}
          <div className="md:col-span-4 lg:col-span-5 grid grid-cols-2 gap-8" data-id="element-32">
            <div className="flex flex-col space-y-4" data-id="element-33">
              {PRIMARY_LINKS.map(link => <a key={link.label} href={link.href} className="text-sm text-atrium-stone hover:text-atrium-bronze transition-colors" data-id="element-34">
                  {link.label}
                </a>)}
            </div>
            <div className="flex flex-col space-y-4" data-id="element-35">
              {SECONDARY_LINKS.map(link => <a key={link.label} href={link.href} className="text-sm text-atrium-stone hover:text-atrium-bronze transition-colors" data-id="element-36">
                  {link.label}
                </a>)}
            </div>
          </div>

          {/* Social */}
          <div className="md:col-span-3 lg:col-span-3 flex flex-col space-y-4" data-id="element-37">
            <span className="text-xs font-bold tracking-[0.15em] uppercase text-atrium-stone mb-2" data-id="element-38">
              Connect
            </span>
            {['Facebook', 'Instagram', 'Houzz'].map(social => <a key={social} href={`#${social.toLowerCase()}`} className="text-sm text-atrium-stone hover:text-atrium-bronze transition-colors" data-id="element-39">
                {social}
              </a>)}
          </div>
        </div>

        {/* Accreditation strip: visible trust marks. Swap text for real logos. */}
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8 py-8 border-t border-atrium-stone/15" data-id="element-40">
          <span className="text-xs font-bold tracking-[0.15em] uppercase text-atrium-stone/70" data-id="element-41">
            Recognised by
          </span>
          <div className="flex flex-wrap items-center gap-3" data-id="element-42">
            {ACCREDITATIONS.map(mark =>
          // <!-- swap = real HIA / MBA / Housing Excellence Awards logo SVG -->
          <span key={mark} className="inline-flex items-center px-3 py-1.5 border border-atrium-stone/25 text-xs font-medium tracking-wide text-atrium-ivory/80 rounded-sm" data-id="element-43">
                {mark}
              </span>)}
          </div>
          <span className="text-xs text-atrium-stone/50 sm:ml-auto" data-id="element-44">
            Recognised by HIA & MBA since 1995
          </span>
        </div>

        <AtriumLine color="stone" className="mb-8 opacity-20" data-id="element-45" />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center text-xs text-atrium-stone/60 space-y-4 md:space-y-0" data-id="element-46">
          <p data-id="element-47">
            &copy; {new Date().getFullYear()} Atrium Homes. All rights reserved.
          </p>
          <div className="flex items-center space-x-6" data-id="element-48">
            {/* <!-- ABN line placeholder comment: ABN XX XXX XXX XXX --> */}
            <span data-id="element-49">ABN Placeholder</span>
            <a href="#privacy" className="hover:text-atrium-stone transition-colors" data-id="element-50">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}